<template>
  <section class="benefits container">
    <h2 class="billing-data__title">A Comprehensive Suite of Learning Tools</h2>

    <div class="benefits__list">
      <div v-for="benefit in benefits" :key="benefit" class="benefits__item">
        <div class="benefits__item-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              fill="#FFC906"
            />
            <path
              d="M17 10L11.5371 15.9073C11.5135 15.9367 11.4856 15.96 11.4548 15.9759C11.424 15.9918 11.391 16 11.3577 16C11.3244 16 11.2914 15.9918 11.2606 15.9759C11.2298 15.96 11.2019 15.9367 11.1783 15.9073L8 12.3077"
              stroke="#363B48"
              stroke-width="1.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="benefits__item-text">{{ benefit }}</div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const benefits = [
  '10,000+ books covered',
  'Community discussions',
  '500+ article and topic guides',
  'Comprehensive podcast summaries',
  'Mobile app (iOS/Android)',
  'Kindle exports',
  'Highlights & notes',
  'PDF downloads',
  'Audio narrations',
  'Premium access to Shortform browser extension',
]
</script>

<style scoped lang="scss">
.benefits {
  &__list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 28px;
    max-width: 660px;
    margin: 0 auto;
    @media (max-width: $w-mobile-s) {
      grid-template-columns: 1fr;
      max-width: 100%;
      margin-inline: 12px;
      margin-top: 30px;
      gap: 14px 28px;
    }
  }

  &__item {
    display: flex;
    gap: 12px;

    &-icon {
      width: 20px;
      height: 20px;
      margin-top: -2px;
    }

    &-text {
      color: $c-black-15;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      max-width: 280px;

      @media (max-width: $w-mobile-s) {
        max-width: 100%;
      }
    }
  }
}

.night-mode {
  .benefits {
    &__item-text {
      color: $c-black-11;
    }
  }
}
</style>
